var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_setup.activeStationGroups),function(group){return _c(_setup.StationLayerGroup,{key:group.band,attrs:{"stations":group.stations,"name":group.name,"pinging-satellite-names":_vm.pingingSatelliteNames,"focus-satellite":_vm.focusSatellite,"get-station-icon":_vm.getStationIcon}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }